import {
  Alignment,
  Button,
  Classes,
  Dialog,
  HTMLTable,
  InputGroup,
  Switch,
} from "@blueprintjs/core";
import { DateInput } from "@blueprintjs/datetime";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { IContestacaoCalc, IEmpresa } from "../../model";
import { ResultadoStore } from "../../stores/resultados/ResultadoStore";
import { getMomentFormatter } from "../../utils";
import MomentLocaleUtils from "react-day-picker/moment";
import { toast } from "react-toastify";
import { MDBCol, MDBRow } from "mdbreact";
import { AppIcon } from "../utils/AppIcon";
import InfoModal from "../info-modal/InfoModal";

interface Props {
  items: IContestacaoCalc[];
  tipo: string;
  empresaSelecionada: IEmpresa;
  modelo: string;
  onClose: () => void;
}

@observer
export class ContestarSugeridoDialog extends React.Component<Props, {}> {

  obs = observable({
    memoria_salvar: false as boolean,
    contestacao_data: null,
    motivo: "",
    itens: [],
    isOpen: false as boolean,
    cnpj_memoria: true as boolean,
    open_ajuda: false as boolean

  })

  constructor(props: any) {
    super(props);

    this.handleQueryAll()

  }

  handleValid() {

    if (!Object.values(this.obs.itens).length) {
      return true
    }

    if (!this.obs.motivo) {
      return true
    }

    return false

  }

  handleQueryAll = async () => {
    ResultadoStore.obs.ids_contestacao_all = []
    ResultadoStore.obs.itemsAllCount = 1

    if (ResultadoStore.obs.contestar_todos && !ResultadoStore.obs.notasRetroativas && !ResultadoStore.obs.notasDivergentes && !ResultadoStore.obs.notasManual) {
      this.obs.itens = []

      await ResultadoStore.queryCalcSugeridos(
        this.props.empresaSelecionada,
        [ResultadoStore.obs.date_start, ResultadoStore.obs.date_end],
        ResultadoStore.obs.icmsClassFilter,
        this.props.tipo,
        this.props.modelo,
        ResultadoStore.obs.filters
      )

      this.obs.itens = { ...ResultadoStore.obs.ids_contestacao_all }

      ResultadoStore.obs.ids_contestacao_all = []
      ResultadoStore.obs.itemsAllCount = 1

    }

    if (!Object.values(this.obs.itens).length) {

      toast.warn("Não foi encontrado nenhum item com cálculo sugerido!")

      this.obs.isOpen = false;

      this.props.onClose()

      return
    }

    this.obs.isOpen = true;

  };

  handleConfirm = async () => {

    let total = 0

    Object.keys(this.obs.itens).map(async key => {

      total += this.obs.itens[key].length

    })

    if (!window.confirm("Você está prestes a contestar " + total + " itens." + "\nObs: Itens que já estão em processo são ignorados!")) {
      this.props.onClose()
      return
    }

    ResultadoStore.obs.working = true

    Object.keys(this.obs.itens).map(async key => {

      let contestacao = {
        contestacao_calc_id: key,
        nota_item_ids: this.obs.itens[key],
        motivo: this.obs.motivo,
        contestacao_data: this.obs.contestacao_data,
        entrada_saida: this.props.tipo.toLocaleLowerCase(),
        modelo: this.props.modelo.toLowerCase(),
        contestacao_produto_id: null
      }

      await ResultadoStore.create_contestacao_task(contestacao, this.obs.memoria_salvar, ResultadoStore.obs.empresaContestar.uf, false, ResultadoStore.obs.empresaContestar.cnpj, ResultadoStore.obs.date_start, ResultadoStore.obs.date_end, this.obs.cnpj_memoria)

    })

    this.obs.isOpen = false

    ResultadoStore.obs.working = false

    ResultadoStore.consulta_resultados_calculo()

    this.props.onClose();

  };

  onClose() {

    this.obs.isOpen = false

    this.props.onClose()

  }

  render() {

    let dayPickerProps = {
      localeUtils: MomentLocaleUtils,
      locale: "pt-br",
    };

    return (
      <>

        <Dialog isOpen={this.obs.isOpen} onClose={() => this.onClose()} className="modal-contestacao">

          <div className={Classes.DIALOG_HEADER}>
            <h2 className="title-no-bottom">Contestar Cálculo</h2>
          </div>

          <div className={Classes.DIALOG_BODY}>

            <HTMLTable className="table table-hover dataTable" style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td style={{ verticalAlign: "middle" }}>
                    Alterar data
                  </td>
                  <td>
                    <DateInput
                      {...getMomentFormatter("DD/MM/YYYY")}
                      locale="pt-br"
                      dayPickerProps={dayPickerProps}
                      value={this.obs.contestacao_data
                        ? new Date(this.obs.contestacao_data)
                        : null}
                      onChange={val => this.obs.contestacao_data = val}
                      placeholder="DD/MM/AAAA"
                      canClearSelection
                    />
                  </td>
                  <td />
                </tr>

                <tr>
                  <td style={{ verticalAlign: "middle" }}>
                    Motivo
                    <b style={{ color: "rgb(219, 83, 83)", marginLeft: 5, fontSize: 14 }}>*</b>
                  </td>
                  <td>
                    <InputGroup
                      value={this.obs.motivo}
                      onChange={(e: any) => this.obs.motivo = e.target.value}
                    />
                  </td>
                  <td />
                </tr>
              </tbody>
            </HTMLTable>

            <MDBRow>
              <MDBCol md="3">
                <div className="consteta-produto-lote-btn">
                  <Switch
                    label={"Salvar contestação"}
                    alignIndicator={Alignment.RIGHT}
                    innerLabelChecked="Sim"
                    innerLabel="Não"
                    checked={this.obs.memoria_salvar}
                    onChange={(e: any) => this.obs.memoria_salvar = e.target.checked}
                  />
                  {this.obs.memoria_salvar &&
                    <div style={{ display: "flex" }}>
                      <label style={{ width: 135 }}>
                        Memória CNPJ
                        <AppIcon
                          name="help"
                          className="pulse-notification-pgdas"
                          color="blue"
                          style={{ cursor: "pointer", marginLeft: 5 }}
                          onClick={(e) => this.obs.open_ajuda = true}
                        />
                      </label>
                      <Switch
                        alignIndicator={Alignment.RIGHT}
                        innerLabelChecked="Sim"
                        innerLabel="Não"
                        checked={this.obs.cnpj_memoria}
                        onChange={(e: any) => this.obs.cnpj_memoria = e.target.checked}
                      />
                    </div>
                  }
                </div>
              </MDBCol>

              <MDBCol md="9">
                <div className="consteta-produto-lote-btn" style={{ textAlign: "right", marginTop: 0 }}>
                  <Button text="Cancelar" onClick={() => this.onClose()} style={{ marginRight: 10, height: "35px" }} />
                  <Button
                    text="Contestar"
                    intent="primary"
                    onClick={this.handleConfirm}
                    loading={ResultadoStore.obs.working}
                    style={{ height: "35px" }}
                    disabled={this.handleValid()}
                  />
                </div>
              </MDBCol>
            </MDBRow>

          </div>
        </Dialog>

        <InfoModal open={this.obs.open_ajuda} onClose={() => this.obs.open_ajuda = false} texto_info={`

          <b>Memória CNPJ:</b><br /><br />

          <b>Ativada</b> – O sistema valida o CNPJ de origem nas entradas e o CNPJ de destino nas saídas para salvar a Memória de Cálculo.<br /><br />

          <b>Desativada</b> – O sistema não realiza a validação de CNPJ, permitindo salvar a Memória de Cálculo sem informações de CNPJ.<br /><br />

        `} />

      </>
    );
  }
}
